import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { List } from "../../shared/list/List";
import { FaList } from "react-icons/fa6";

export const ListaProposta = ({
    columns,
    data,
    page,
    setPage,
    limit,
    setLimit,
    total,
    loading,
    handleFiltering,
    storageKey,
    setDataInicio,
    dataInicio,
    setDataFim,
    dataFim,
    handleFiltroData,
    getRowStyle,
    getRowClassName, 
    legend
}) => {
    const table = { columns, data };
    const navigate = useNavigate();
    const initialVisibleColumns = ["ordcom", "codope", "nomope", "codpro", "tippro", "qtdpro", "valpro", "status", "status_res", "datpro"];
    const [columnFilters, setColumnFilters] = useState([]);
    const [showModal, setShowModal] = useState(false);

    const handleVisualizarProposta = (row) => navigate(`/propostas/${row.ordcom}`);

    const handleAplicarFiltroData = () => {
        if (handleFiltroData) {
            handleFiltroData();
        }

        setShowModal(false);
    };

    return (
        <List
            title="Propostas"
            text="Lista de Propostas"
            table={table}
            actions={[{
                icon: FaList,
                onClick: handleVisualizarProposta,
                title: "Visualizar Itens"
            }]}
            page={page}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            total={total}
            onColumnFilterChange={handleFiltering}
            columnFilters={columnFilters}
            setColumnFilters={setColumnFilters}
            initialVisibleColumns={initialVisibleColumns}
            setDataInicio={setDataInicio}
            dataInicio={dataInicio}
            setDataFim={setDataFim}
            dataFim={dataFim}
            handleFilterData={handleAplicarFiltroData}
            showModal={showModal}
            setShowModal={setShowModal}
            storageKey={storageKey}
            legend={legend}
            loading={loading}
            getRowStyle={getRowStyle}
            getRowClassName={getRowClassName}
            enableRowSelection={false}
        />
    );
};
